/* eslint-disable react/jsx-pascal-case */
import moment from "moment";
import { useState } from "react";
import styled from "styled-components";
import { fontStyles } from "../../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";

const Container = styled.div`
  flex: 1;
  width: 100%;
  margin-right: 1rem;
  margin-bottom: 1rem;
`;
const DateBox = styled.div`
  margin-right: 1rem;
  font-size: 26px;
  ${fontStyles.Bold}
`;
const Header = styled(RowView)`
  margin-top: 0.5rem;
  border: 1px solid #f0f0f0;
  div {
    flex: 1;
    padding: 0.5rem 0rem;
    text-align: center;
    background-color: #f0f0f0;
  }
`;
const RowGrid = styled.div`
  flex: 1;
  height: 37rem;
  border-left: 1px solid #f0f0f0;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
`;
const Commute_Box = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  color: #606060;
  border: 1px solid #f1f1f1;
  border-top: 0px;
  border-left: 0px;
  cursor: pointer;
  &.this {
    color: #ea2922;
    background-color: #ffe9e8;
    border: 1px solid #ea2922;
    cursor: default;
    div {
      border-color: #ea2922;
    }
  }
  &.empty {
    background-color: white;
    color: lightgray;
    cursor: default;
  }
`;
const Day_Date = styled.div`
  padding: 0.3rem 0rem;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  &.none {
    color: #c5c5c5;
    background-color: #fafafa;
    cursor: default;
  }
`;
const PositionBox = styled(CenterView)`
  flex: 1;
  font-size: 14px;
  cursor: pointer;
  &.none {
    color: #c5c5c5;
    background-color: #fafafa;
    cursor: default;
  }
`;

interface SettingDate {
  livedate: string;
  setLivedate: React.Dispatch<React.SetStateAction<string>>;
  setLivetime: React.Dispatch<React.SetStateAction<number[]>>;
}

const Canendar = (props: SettingDate) => {
  const livedate = props.livedate;
  const setLivedate = props.setLivedate;
  const setLivetime = props.setLivetime;

  const setting_livedate = (date: string) => {
    setLivedate(date);
    setLivetime([]); // 초기화
  };

  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  const currentYear = currentDate ? currentDate.getFullYear() : 0;
  const currentMonth = currentDate ? currentDate.getMonth() : 0;

  const prevMonth = () =>
    setCurrentDate(new Date(currentYear, currentMonth - 1, 1));
  const nextMonth = () =>
    setCurrentDate(new Date(currentYear, currentMonth + 1, 1));

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
  const lastDayOfpreMonth = new Date(currentYear, currentMonth, 0).getDate();
  const nextDayOfMonth = new Date(currentYear, currentMonth + 1, 1).getDay();

  const emptyLength = Array(firstDayOfMonth).fill("");
  const dayLength = Array(daysInMonth).fill("");
  const nextLength = Array(6 - nextDayOfMonth + 1).fill("");

  const isNone = (date: string) => {
    if (date === moment(new Date()).format("YYYY-MM-DD")) {
      return false;
    }
    const targetDate = new Date(date);
    const isPast: boolean =
      moment(targetDate).format("YYYYMMDD") <
      moment(new Date()).format("YYYYMMDD");
    return isPast;
  };

  return (
    <Container>
      <RowView2>
        <DateBox>
          {currentYear}년 {currentMonth > 8 || "0"}
          {currentMonth + 1}월
        </DateBox>
        <RowView2
          style={{ marginRight: "1rem" }}
          className="pointer"
          onClick={prevMonth}
        >
          <Icon src={require("../../../../Image/Admin/ic_paging_left.png")} />
          이전달
        </RowView2>
        <RowView2 className="pointer" onClick={nextMonth}>
          다음달
          <Icon src={require("../../../../Image/Admin/ic_paging_right.png")} />
        </RowView2>
      </RowView2>

      <Header>
        <div className="sunday">일</div>
        <div>월</div>
        <div>화</div>
        <div>수</div>
        <div>목</div>
        <div>금</div>
        <div className="saturday">토</div>
      </Header>

      <RowGrid>
        {emptyLength.map((_, idx) => {
          const day = lastDayOfpreMonth - (emptyLength.length - 1 - idx);

          return (
            <Commute_Box key={idx} className="empty">
              <Day_Date>{day}</Day_Date>
            </Commute_Box>
          );
        })}

        {dayLength.map((_, idx) => {
          const day = (idx + 1).toString().padStart(2, "0");
          const month = (currentMonth + 1).toString().padStart(2, "0");
          const YYYYMMDD = `${currentYear}-${month}-${day}`;

          return (
            <Commute_Box
              className={livedate === YYYYMMDD ? "this" : ""}
              key={idx}
              onClick={() => {
                if (!isNone(YYYYMMDD)) {
                  setting_livedate(YYYYMMDD);
                }
              }}
            >
              <Day_Date className={isNone(YYYYMMDD) ? "none" : ""}>
                {idx + 1}
              </Day_Date>

              <PositionBox className={isNone(YYYYMMDD) ? "none" : ""}>
                {isNone(YYYYMMDD) ? "예약불가" : "예약가능"}
              </PositionBox>
            </Commute_Box>
          );
        })}

        {nextLength.length !== 7 &&
          nextLength.map((_, idx) => {
            return (
              <Commute_Box key={idx} className="empty">
                <Day_Date>{idx + 1}</Day_Date>
              </Commute_Box>
            );
          })}
      </RowGrid>
    </Container>
  );
};

export default Canendar;
